const soap = {
    "90":"Такого пользователя не существует"
};
export default soap